import { SimpleChanges, Directive, ElementRef, AfterViewChecked, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Util } from '../utils/index';

declare var $:any;
declare var moment:any;

@Directive({
  selector: '[datepicker],[datetimepicker],[timepicker],[datepickerMindate]',
})
export class DatePickerDirective {

  constructor(
      private elementRef: ElementRef,
  ) {
      this.el = this.elementRef.nativeElement;
      this.dtpLocale = moment().locale() || this.dtpLocale;
  }

  private el: HTMLInputElement;
  private $element;
  private _minDate: Date;
  private _maxDate: Date;

  @Input()
  dtpFormat = 'L LT';
  
  @Input()
  dtpLocale = null;

  @Input()
  dtpTime = true;

  @Input()
  dtpDate = true;
  
  @Input()
  public set datetimepicker(s: string) { 
    this.dtpDate = true; 
    this.dtpTime = true; 
    this.dtpFormat = 'L LT';
    // this._minDate = new Date();
  }
  @Input()
  public set datepicker(s: string) { 
    this.dtpDate = true; 
    this.dtpTime = false;
    this.dtpFormat = 'L';
  }
  @Input()
  public set datepickerMindate(s: string) { 
    this.dtpDate = true; 
    this.dtpTime = false;
    this.dtpFormat = 'L';
    this._minDate = new Date();
  }
  @Input()
  public set timepicker(s: string) { 
    this.dtpDate = false; 
    this.dtpTime = true; 
    this.dtpFormat = 'LT';
  }
  @Input()
  public set date(d: Date) {
    this.el.value = moment(new Date(d)).format(this.dtpFormat);
  }

  @Input()
  public set minDate(date: string) {
    if (!this.$element) return;
    if (!date) this.$element.bootstrapMaterialDatePicker('setMinDate', null);
    let dateDt = Util.parseDate(date);
    if (!dateDt) this.$element.bootstrapMaterialDatePicker('setMinDate', null);

    this._minDate = dateDt;
    this.$element.bootstrapMaterialDatePicker('setMinDate', this._minDate);
  }
  
  @Input()
  public set maxDate(date: string) {
    if (!this.$element) return;
    if (!date) this.$element.bootstrapMaterialDatePicker('setMaxDate', null);
    let dateDt = Util.parseDate(date);
    if (!dateDt) this.$element.bootstrapMaterialDatePicker('setMaxDate', null);

    this._maxDate = dateDt;
    this.$element.bootstrapMaterialDatePicker('setMaxDate', this._maxDate);
  }

  @Output()
  dateChange: EventEmitter<Date> = new EventEmitter();
  
  ngOnInit() {
    this.$element = $(this.el);
    
    this.$element.bootstrapMaterialDatePicker({
        date: this.dtpDate,
        time: this.dtpTime,
        format: this.dtpFormat,
        lang: this.dtpLocale,
        minDate: this._minDate,
        maxDate: this._maxDate,
        clearButton: true
    });
    
    let $calendar = $('#' + this.$element.attr('data-dtp'));
    
    $calendar.find('.dtp-select-month-before, .dtp-select-year-before .material-icons').text('<');
    $calendar.find('.dtp-select-month-after, .dtp-select-year-after .material-icons').text('>');
    $calendar.find('.dtp-close a .material-icons').text('x');

    this.$element.on('change',()=> {
        this.dateChange.emit(moment(this.$element.val(), this.dtpFormat).toDate());
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/datepicker.ts